import { typography } from '@joor/design-system'
import styled from 'styled-components/macro'

import { ProvidedAddress } from '../UpdateAddressMismatchModal'

export function MismatchContent({
  csdAddress,
  editedAddress,
}: {
  csdAddress: ProvidedAddress
  editedAddress: ProvidedAddress
}) {
  return (
    <Container>
      <Description>
        The address you provided differs from the one saved at your account
        level.
        <br />
        Would you like to update it for this order only or update your account
        as well?
      </Description>
      <Note>
        Note: Updates to the account level address will only affect new orders.
        Existing orders will retain their current address.
      </Note>
      <CompareWrapper>
        <ProvidedAddressColumn
          title="This Order"
          address={csdAddress}
          testId="this-order-column"
        />
        <ProvidedAddressColumn
          title="Account Level"
          address={editedAddress}
          testId="account-level-column"
        />
      </CompareWrapper>
    </Container>
  )
}

const Container = styled.div`
  min-height: 256px;
`

const Description = styled.p`
  ${typography.alpha.primaryActive.body3}
  margin-top: 0;
`
const Note = styled.p`
  ${typography.alpha.primaryActive.body2}
  margin-top: 0;
  margin-bottom: 16px;
`

const CompareWrapper = styled.div`
  display: flex;
  gap: 16px;
`

function ProvidedAddressColumn({
  title,
  address,
  testId,
}: {
  title: string
  address: ProvidedAddress
  testId?: string
}) {
  return (
    <Column data-testid={testId}>
      <Title>{title}</Title>
      <div>
        <Subtitle>{address.companyName}</Subtitle>
        <Line>{address.addressFull}</Line>
        <Line>{address.phoneNumber}</Line>
        <Line>{address.email}</Line>
      </div>
    </Column>
  )
}

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

const Title = styled.h6`
  ${typography.alpha.primaryActive.subtitle1}
  margin: 0 !important;
`

const Subtitle = styled.p`
  margin: 0;
  ${typography.alpha.primaryActive.subtitle3}
`

const Line = styled.p`
  margin: 0;
  ${typography.alpha.primaryActive.body1}
`
